<div class="pms-messages-widget">
  <div class="header" *ngIf="currentPage === 1">
    <div class="title">{{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.TITLE' | translate }}</div>
  </div>

  <!-- Message List -->
  <div class="message-list" *ngIf="currentPage === 1">
    <div class="message-table">
      <div class="table-header">
        <div class="header-cell indicator"></div>
        <div class="header-cell date">{{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.DATE' | translate }}</div>
        <div class="header-cell time">{{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.TIME' | translate }}</div>
        <div class="header-cell message">{{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.MESSAGE' | translate }}</div>
      </div>
      <div class="table-body">
        <div
          *ngFor="let msg of messages; let first = first"
          class="message-row htv-selectable"
          [class.unread]="!msg.readAt"
          [class.htv-focus-10]="first"
          (click)="selectMessage(msg)">
          <div class="cell indicator">
            <div class="unread-indicator" *ngIf="!msg.readAt"></div>
          </div>
          <div class="cell date">{{ msg.createdAt | momentp: 'L' }}</div>
          <div class="cell time">{{ msg.createdAt | momentp: 'LT' }}</div>
          <div class="cell message">{{ msg.title || '-' }}</div>
        </div>
      </div>
    </div>
    <div class="no-messages" *ngIf="messages.length === 0">
      {{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.NO_MESSAGES' | translate }}
    </div>
  </div>

  <!-- Message Detail -->
  <div class="message-detail" *ngIf="currentPage === 2 && selectedMessage">
    <div class="detail-header-section">
      <div class="header-row">
        <span class="header-label">{{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.FROM' | translate }}:</span>
        <span class="header-value">{{ selectedMessage.senderName || '-' }}</span>
      </div>
      <div class="header-row">
        <span class="header-label">{{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.RECEIVED' | translate }}:</span>
        <span class="header-value">
          {{ selectedMessage.createdAt | momentp: 'L' }} {{ selectedMessage.createdAt | momentp: 'LT' }}
        </span>
      </div>
      <div class="header-row">
        <span class="header-label">{{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.SUBJECT' | translate }}:</span>
        <span class="header-value">{{ selectedMessage.title || '-' }}</span>
      </div>
    </div>

    <div class="detail-content-section">
      <div class="content-text">
        {{ selectedMessage.content }}
      </div>
    </div>

    <div class="detail-actions-section">
      <button class="action-button htv-selectable htv-focus-10" (click)="goBack()">
        {{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.BACK_TO_MESSAGES' | translate }}
      </button>
      <button class="action-button htv-selectable" (click)="deleteMessage()">
        {{ 'WIDGETS.MARRIOTT_PMS_MESSAGES.DELETE' | translate }}
      </button>
    </div>
  </div>

  <div class="info-section" *ngIf="currentPage === 1">
    <div class="info-text">
      {{ informativeText | translate: { count: unreadCount } }}
    </div>
  </div>
</div>
